"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/********************************************* SETUP **********************************************/
require("./setup/setup");
/********************************** BARREL EXPORT TYPES & UTILS ***********************************/
var javelin_factory_1 = require("./util/javelin-factory");
exports.javelinFactory = javelin_factory_1.javelinFactory;
// Export region data
var RegionCollection = __importStar(require("./data/hydrators/regions"));
exports.RegionCollection = RegionCollection;
/**
 * Main JVLNS exports:
 *     -   Data types & classes interacted with by consuming projects
 *     -   JVLNS Date objects/classes
 *     -   Instances of various Javelin manager implementations
 *     -   More hardcoded region data
 *     -   Result-handling objects (both success and error)
 */
var javelin_exports_1 = require("./javelin-exports");
// Core exports
exports.Record = javelin_exports_1.Record;
exports.Dose = javelin_exports_1.Dose;
exports.Page = javelin_exports_1.Page;
exports.OtherPage = javelin_exports_1.OtherPage;
exports.Banner = javelin_exports_1.Banner;
exports.TradeNameConcept = javelin_exports_1.TradeNameConcept;
exports.GenericConcept = javelin_exports_1.GenericConcept;
exports.Schedule = javelin_exports_1.Schedule;
// Region data / typings
exports.regionArray = javelin_exports_1.regionArray;
exports.buildRegionObj = javelin_exports_1.buildRegionObj;
exports.getRegionName = javelin_exports_1.getRegionName;
// Dates
exports.LocalDate = javelin_exports_1.LocalDate;
exports.ZonedDateTime = javelin_exports_1.ZonedDateTime;
exports.NotificationManager = javelin_exports_1.NotificationManager;
exports.SchedulerManager = javelin_exports_1.SchedulerManager;
// PHUs (including OPH)
exports.PHUConfig = javelin_exports_1.PHUConfig;
exports.PHUIntegration = javelin_exports_1.PHUIntegration;
// Misc data types
exports.Relationship = javelin_exports_1.Relationship;
exports.Gender = javelin_exports_1.Gender;
exports.Field = javelin_exports_1.Field;
exports.RequestCallback = javelin_exports_1.RequestCallback;
exports.City = javelin_exports_1.City;
exports.Country = javelin_exports_1.Country;
exports.AccountValidation = javelin_exports_1.AccountValidation;
// Banners
var banners_1 = require("./data/hydrators/banners");
exports.bannerCollectionFactory = banners_1.bannerCollectionFactory;
// Extra date functionality: extractLocalDate
__export(require("./date/date-helpers"));
/**
 * Javelin data handler implementation
 */
var javelin_data_1 = require("./data/javelin-data");
exports.JavelinData = javelin_data_1.JavelinData;
// Store data in localForage
var temp_localforage_storage_1 = require("./util/temp-localforage-storage");
/**
 * [TEMP] localStorage-based store
 * Used to get data from JVLNS methods with no return callbacks (@TODO)
 */
exports.SSTemp = { clearAll: temp_localforage_storage_1.clearAll, getItem: temp_localforage_storage_1.getItem, removeItem: temp_localforage_storage_1.removeItem, setItem: temp_localforage_storage_1.setItem, getAll: temp_localforage_storage_1.getAll, getAllAndClear: temp_localforage_storage_1.getAllAndClear };
/**
 * Javelin internal data store
 */
var store_1 = require("./data/store/store");
exports.javelinDataStore = store_1.store;
// Export broadcast handling
var broadcaster_1 = require("./data/store/broadcaster");
exports.Broadcaster = broadcaster_1.Broadcaster;
/**
 * Raw, untyped Javelin bundle
 * Nainly for debugging/testing/experimentation purposes - for production, use
 * the typed exports instead: anything in the above "Main JVLNS exports" block,
 * initJavelinSequence
 */
var javelin_exports_2 = require("./javelin-exports");
exports.javelin = javelin_exports_2.javelin;
//# sourceMappingURL=index.js.map